import React, { StatelessComponent } from 'react';
import { Illustration, IllustrationSizeProps } from './illustration';
import src from '!svg-url-loader?noquotes=true!grpn-mx-mixer/dist/images/illustrative-icons/merchant-center.svg';

export const IllustrationMerchantCenter: StatelessComponent<IllustrationSizeProps> = (
  props: IllustrationSizeProps,
) => <Illustration src={src} {...props} />;
